import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Cf2MaterialModule } from '@modules/cf2-material/cf2-material.module';

@Component({
    selector: 'app-client-navigation',
    templateUrl: './client-navigation.component.html',
    styleUrls: ['./client-navigation.component.scss'],
    imports: [
      CommonModule,
      ReactiveFormsModule,
      Cf2MaterialModule,
    ]
})
export class ClientNavigationComponent {

  public applicationTitle = 'WCG';
}
